import { MessageType, ToastType } from '../app/shared/types';

export interface ErrorConfig {
  timer: number;
  level?: ToastType;
  messageType?: MessageType;
  closeOnTimerOrButton?: boolean;
}

export const ERROR_CONFIGS: Record<string, ErrorConfig> = {
  DEFAULT_TOAST_CONFIG: {
    level: ToastType.SUCCESS,
    timer: 1500,
    closeOnTimerOrButton: true,
  },
};
